import React, { useState, useEffect, useContext, useRef } from 'react';
import { Container, Table, Button, Row, Col, Badge, Image, Alert } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import api from '../../services/api';
import './Order.css';
import { useTranslation } from 'react-i18next'

const OrderDetail = () => {
  const { orderId } = useParams();
  const { t, i18n } = useTranslation();
  const { user } = useContext(AuthContext);
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const [canUpdate, setCanUpdate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);
  let [newArray, setNewArray] = useState([]);
  let cutoff_str = useRef('CUTOFF_1');

  useEffect(() => {
    if (orderId) {
      loadOrderDetails();
    }
  }, [orderId]);

  const loadOrderDetails = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/orders/${orderId}`);
      const orderData = await response.data.data;
      setOrder(await orderData);
      // document.getElementById("btn_delete").disabled = false;
      // document.getElementById("btn_edit").disabled = false;
      if(orderData.sales_office === 'MT'){
        cutoff_str.current = 'CUTOFF_1';
      }
      if(orderData.sales_office === 'GT'){
        cutoff_str.current = 'CUTOFF_2';
      }
      const configResponse = await api.get(`/sharedconfigs/`+cutoff_str.current);
      if (await configResponse.data.data.zvalue) {
        const cutoff = configResponse.data.data.zvalue;
        const hktTime = new Date(configResponse.data.data.dt).toLocaleString('en-HK', { timeZone: 'Asia/Hong_Kong', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
        cutoff.replaceAll(':', '');
        hktTime.replaceAll(':', '');

        if (orderData.status === 'O') {
          if(orderData.sync_to_sap === 2){
            setCanUpdate(false);
            setCanDelete(true);
          }else{
            setCanUpdate(true);
            setCanDelete(true);            
          }
        } else {
          setCanUpdate(false);
          setCanDelete(false);
        }
      }
      setError('');

      // 如果是客戶且不是關聯的客戶，重定向到訂單列表
      if (user.role !== 0) {
        const userRelatedCustomers = await api.get('/auth/customers');
        const customerCodes = userRelatedCustomers.data.data.map(c => c.cust_code);

        if (!customerCodes.includes(orderData.cust_code)) {
          navigate('/orders');
        }
      }

      newArray = [];
      setNewArray([]);
      orderData.items.forEach((item) => {
        const existingItem = newArray.find(p => p.item_code === item.item_code);
        if (item.tran_code === 'ZNS') {
          if (newArray.find(p => p.item_code === item.item_code)) {
            existingItem.orderQty += parseInt(item.qty);
          } else {
            newArray.push({ item_code: item.item_code, item_desc: item.item_desc, tran_code: item.tran_code, orderQty: parseInt(item.qty), replaceQty: 0, sampleQty: 0 });
          }
        } else if (item.tran_code === 'ZRP') {
          if (newArray.find(p => p.item_code === item.item_code)) {
            existingItem.replaceQty += parseInt(item.qty);
          } else {
            newArray.push({ item_code: item.item_code, item_desc: item.item_desc, tran_code: item.tran_code, orderQty: 0, replaceQty: parseInt(item.qty), sampleQty: 0 });
          }
        } else {
          if (newArray.find(p => p.item_code === item.item_code)) {
            existingItem.sampleQty += parseInt(item.qty);
          } else {
            newArray.push({ item_code: item.item_code, item_desc: item.item_desc, tran_code: item.tran_code, orderQty: 0, replaceQty: 0, sampleQty: parseInt(item.qty) });
          }
        }
      });
      setNewArray(newArray)

    } catch (err) {
      console.error('載入訂單詳情失敗:', err);
      setError('載入訂單詳情失敗: ' + (err.response?.data?.message || '請稍後再試'));
      window.scrollTo(0, 0);
      // 如果訂單不存在或無權訪問，重定向到訂單列表
      if (err.response?.status === 404 || err.response?.status === 403) {
        navigate('/orders');
      }
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-TW');;
  };

  const handleBack = () => {
    navigate('/orders');
  };

  const handleRefresh = () => {
    loadOrderDetails();
  };

  const handleEdit = async () => {
    try {
      const response = await api.get(`/orders/${orderId}`);
      const orderData = await response.data.data;
      if(orderData.sales_office === 'MT'){
        cutoff_str.current = 'CUTOFF_1';
      }
      if(orderData.sales_office === 'GT'){
        cutoff_str.current = 'CUTOFF_2';
      }
      const configResponse = await api.get(`/sharedconfigs/`+cutoff_str.current);
      if (await configResponse.data.data.zvalue) {
        const cutoff = configResponse.data.data.zvalue;
        const hktTime = new Date(configResponse.data.data.dt).toLocaleString('en-HK', { timeZone: 'Asia/Hong_Kong', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
        cutoff.replaceAll(':', '');
        hktTime.replaceAll(':', '');

        if (orderData.status === 'O') {
          if(orderData.sync_to_sap === 2){
            setCanUpdate(false);
            setCanDelete(true);
          }else{
            setCanUpdate(true);
            setCanDelete(true);            
          }
        } else {
          setCanUpdate(false);
          setCanDelete(false);
        }
      }
      if (orderData.delete_flag === 1 || orderData.sync_to_sap === 1) {
        setError(t('msg_orderChanged'));
        window.scrollTo(0, 0);
      } else {
        navigate(`/orders/edit/${orderId}`);
      }
    } catch (err) {
      setError('載入訂單詳情失敗: ' + (err.response?.data?.message || '請稍後再試'));
      window.scrollTo(0, 0);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await api.get(`/orders/${orderId}`);
      const orderData = response.data.data;
      if(orderData.sales_office === 'MT'){
        cutoff_str.current = 'CUTOFF_1';
      }
      if(orderData.sales_office === 'GT'){
        cutoff_str.current = 'CUTOFF_2';
      }
      const configResponse = await api.get(`/sharedconfigs/`+cutoff_str.current);
      if (await configResponse.data.data.zvalue) {
        const cutoff = configResponse.data.data.zvalue;
        const hktTime = new Date(configResponse.data.data.dt).toLocaleString('en-HK', { timeZone: 'Asia/Hong_Kong', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
        cutoff.replaceAll(':', '');
        hktTime.replaceAll(':', '');
        if (orderData.status === 'O') {
          if(orderData.sync_to_sap === 2){
            setCanUpdate(false);
            setCanDelete(true);
          }else{
            setCanUpdate(true);
            setCanDelete(true);            
          }
        } else {
          setCanUpdate(false);
          setCanDelete(false);
        }
      }
      if (orderData.delete_flag === 1 || orderData.sync_to_sap === 1 || ( canUpdate === false && canDelete === false) ) {
        setError(t('msg_orderChanged'));
        window.scrollTo(0, 0);
      } else {
        document.getElementById("myConfirm").style.display = "block"
      }
    } catch (err) {
      setError('載入訂單詳情失敗: ' + (err.response?.data?.message || '請稍後再試'));
      window.scrollTo(0, 0);
    }
  };

  const confirmDelete = async () => {
    document.getElementById("myConfirm").style.display = "none";
    const response = await api.put(`/orders/${orderId}`, { action: 'D' });
    if (await response.data.success === true) {
      setSuccess(t('msg_deleteSuccess'));
      const delay = ms => new Promise(res => setTimeout(res, ms));
      await delay(3000);
      navigate(`/orders/`);
    } else {
      setError(t('msg_deleteFailed'));
      window.scrollTo(0, 0);
    }
  };

  const closeConfirm = async (e) => {
    document.getElementById("myConfirm").style.display = "none";
  }


  // 獲取產品圖片或使用預設圖片
  const getProductImage = (item) => {
    if (item.image_url) {
      return item.image_url;
    } else {
      return '/images/products/' + item.item_code + '.png';
    }
    // 根據部門返回預設圖片
    //return item.div === '10' 
    //  ? '/images/default-milk.png' 
    //  : '/images/default-ice-cream.png';
  };

  const getStatus = (order) => {
    if (order.status === 'C') {
      return i18n.t('cancelled');
    } else if (order.status === 'P') {
      return i18n.t('processing');
    } else if (order.status === 'D') {
      return i18n.t('completed');
    } else if (order.status === 'O') {
      return i18n.t('created');
    } else {
      return i18n.t('unknown');
    }
  };

  return (
    <Container className="order-detail-container">
      <Row className="mb-3 align-items-center">
        <Col xs={12} md={6}>
          <h5 className="text-muted">({t('orderNo')}: {orderId})</h5>
        </Col>
        {canUpdate && canDelete ?
          (<Col xs={12} md={6} className="text-md-end">
            <Button variant="outline-primary" className="mt-2 me-2" onClick={handleRefresh}>
              {t('refresh')}
            </Button>
            <Button variant="danger" className="mt-2 me-2" onClick={handleDelete} id="btn_delete">
              {t('deleteOrder')}
            </Button>
            <Button variant="warning" className="mt-2 me-2" onClick={handleEdit} id="btn_edit">
              {t('editOrder')}
            </Button>
            <Button variant="outline-success" className="mt-2" onClick={handleBack}>
              {t('backToList')}
            </Button>
          </Col>) : canDelete === true ?
          (<Col xs={12} md={6} className="text-md-end">
            <Button variant="outline-primary" className="mt-2 me-2" onClick={handleRefresh}>
              {t('refresh')}
            </Button>
            <Button variant="danger" className="mt-2 me-2" onClick={handleDelete} id="btn_delete">
              {t('deleteOrder')}
            </Button>
            <Button variant="secondary" className="mt-2 me-2" onClick={handleEdit} id="btn_edit" disabled>
              {t('editOrder')}
            </Button>
            <Button variant="outline-success" className="mt-2" onClick={handleBack}>
              {t('backToList')}
            </Button>
          </Col>) :
          (<Col xs={12} md={6} className="text-md-end">
            <Button variant="outline-primary" className="mt-2 me-2" onClick={handleRefresh}>
              {t('refresh')}
            </Button>
            <Button variant="secondary" className="mt-2 me-2" onClick={handleDelete} id="btn_delete" disabled>
              {t('deleteOrder')}
            </Button>
            <Button variant="secondary" className="mt-2 me-2" onClick={handleEdit} id="btn_edit" disabled>
              {t('editOrder')}
            </Button>
            <Button variant="outline-success" className="mt-2" onClick={handleBack}>
              {t('backToList')}
            </Button>
          </Col>) 
        }

      </Row>

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <Alert variant="success">{success}</Alert>}

      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">{t('loading')}</span>
          </div>
        </div>
      ) : order ? (
        <>
          <div id="myConfirm" className="confirm">
            <div className="confirm-content">
              <h6>&nbsp;</h6>
              <p style={{ textAlign: 'center' }}>{t('msg_confirmDelete')}</p>
              <span>
                <Button
                  variant="success"
                  className="m-2"
                  style={{ width: '80px', height: '35px', padding: '2px', margin: '3px', float: 'left' }}
                  onClick={() => confirmDelete()}
                >
                  {t('yes')}
                </Button>
                <Button
                  variant="secondary"
                  className="m-2"
                  style={{ width: '80px', height: '35px', padding: '2px', margin: '3px' }}
                  onClick={() => closeConfirm()}
                >
                  {t('cancel')}
                </Button>
              </span>
            </div>
          </div>

          <h5>{t('order')} {getStatus(order)}</h5>
          <div className="order-info mb-2">
            <p className="mb-1"><strong>{t('store')}:</strong> {order.cust_name} ({order.cust_code})</p>
            <p className="mb-1"><strong>{t('deliveryDate')}:</strong> {formatDate(order.delivery_date)}</p>
            <p className="mb-1"><strong>{t('createDate')}:</strong> {formatDate(order.created_at)}</p>
            <p className="mb-1"><strong>{t('totalQty')}:</strong> {order.items.reduce((total, item) => total + parseInt(item.qty), 0)} {t('pieces')}</p>
          </div>

          {/* <h5>{t('lineItem')}</h5> */}
          <div className="table-responsive">
            <Table className="order-items-table">
              <thead>
                <tr>
                  <th style={{ fontSize: '100%', padding: '3px' }}></th>
                  <th style={{ fontSize: '100%', padding: '3px' }}>{t('product')}</th>
                  <th style={{ textAlign: 'center', fontSize: '120%', padding: '3px' }}><Badge bg="success">{t('sales')}</Badge></th>
                  <th style={{ textAlign: 'center', fontSize: '120%', padding: '3px' }}><Badge bg="warning">{t('replace')}</Badge></th>
                  {/* {user.role !== 0 ? <></> : <th style={{ textAlign: 'center', fontSize: '120%', padding: '3px' }}><Badge bg="secondary">{t('sample')}</Badge></th>} */}
                  {/* <th style={{ textAlign: 'center', fontSize: '100%', padding: '3px' }}>{t('qty')}</th> */}
                </tr>
              </thead>
              <tbody>
                {newArray.map((item) => (
                  <tr key={item.item_code}>
                    <td style={{ maxWidth: '80px', padding: '3px' }}>
                      <div className="detail-image">
                        <Image src={getProductImage(item)} alt={item.item_desc} />
                      </div>
                    </td>
                    <td style={{ maxWidth: '200px', fontSize: 'clamp(1rem, 2vw, 1.25rem)', padding: '3px' }}>
                      <span>{item.item_desc}</span>
                    </td>
                    {/* <td style={{ minWidth: '40px', textAlign: 'center', padding: '3px' }}>
                      {item.tran_code === 'ZNS' ? (
                        <Badge bg="success">{t('sales')}</Badge>
                      ) : item.tran_code === 'ZRP' ? (
                        <Badge bg="warning">{t('replace')}</Badge>
                      ) : item.tran_code === 'ZSA' ? (
                        <Badge bg="secondary">{t('sample')}</Badge>
                      ) : (
                        <Badge bg="primary">{item.tran_code}</Badge>
                      )}
                    </td> */}
                    <td style={{ minWidth: '40px', fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', textAlign: 'center', padding: '3px' }}>{parseInt(item.orderQty) || ''}</td>
                    <td style={{ minWidth: '40px', fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', textAlign: 'center', padding: '3px' }}>{parseInt(item.replaceQty) || ''}</td>
                    {/* {user.role !== 0 ? <></> :
                      <td style={{ minWidth: '40px', fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', textAlign: 'center', padding: '3px' }}>{parseInt(item.sampleQty) || ''}</td>} */}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className="order-summary mt-4 text-end">
            <p><strong>{t('totalQty')}:</strong> {order.items.reduce((total, item) => total + parseInt(item.qty), 0)} {t('pieces')}</p>
          </div>
        </>
      ) : (
        <div className="text-center my-5">
          <p>{t('noOrderInfo')}</p>
          <Button variant="outline-primary" onClick={handleBack}>
            {t('backToList')}
          </Button>
        </div>
      )}
    </Container>
  );
};

export default OrderDetail;